module.exports = __webpack_public_path__ + "img/linkedin.213bcf67.svg";